import { DialogViewActionWidget, SPI, ActionWidget, ActionType, Condition } from '@kunlun/dependencies';
@SPI.ClassFactory(
  ActionWidget.Token({
    actionType: ActionType.View,
    name: 'uiView08f37ee70e9741c3b64fefe0e4bbc089',
    model: 'deli.aries.promotion.DeliAriesPromotionPlanDisableProxy'
  })
)
export class createdSearch extends DialogViewActionWidget {
  protected async clickAction(): Promise<void> {
    this.action.context!.planId = `"${this.searchBody!.planId}"`;
    await super.clickAction();
    return;
  }
}
